function checkAndSelectVariantRadio() {
  const currentURL = window.location.href;
  if (!currentURL.includes('products')) return;

  const variantTitle = localStorage.getItem('variant_title');
  if (!variantTitle) return;

  const matchingInputs = document.querySelectorAll(
    `input[type="radio"][data-variant-value="${variantTitle}"]`
  );

  // Exit if no matches found
  if (!matchingInputs.length) return;

  // [Archies 2026-10-20] Uncheck only within each matching input's own option group. Unchecking every radio on
  // the page cleared a combined listing's hidden style option, and VariantRadios then threw with nothing checked
  // (NZ outage 2026-10-02). A remembered size only ever belongs to the size group.
  matchingInputs.forEach((input) => {
    const group = input.closest('fieldset') || document;
    group.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
    });
    input.checked = true;
  });
}

checkAndSelectVariantRadio();